module.exports = __webpack_public_path__ + "assets/img/o2.e3ad47f0.png";